import { render, staticRenderFns } from "./SoftText.vue?vue&type=template&id=92bff704&scoped=true&"
import script from "./SoftText.vue?vue&type=script&lang=js&"
export * from "./SoftText.vue?vue&type=script&lang=js&"
import style0 from "./SoftText.vue?vue&type=style&index=0&id=92bff704&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92bff704",
  null
  
)

export default component.exports